import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { load, start } from '../../store/composition/composition.js';
import { compositionTypes } from '../../store/composition/helpers.js';
import { launchElearning } from '../../store/elearning/elearning';
import { translate } from '../../helpers/translate.js';
import '@sdb-develop/learning-frontend';

@customElement('sdb-composition-start-button')
class SdbCompositionStartButton extends connect(store)(LitElement)
 {

    @property({ type: String })
    accessor compositionId;

    @property({type: Boolean})
    accessor disabled = false;

    @property({type: Boolean})
    accessor light = false;

    @state()
    accessor composition;

    @state()
    accessor isLoading = false;

    @state()
    accessor ready = false;

    stateChanged(state) {
        this.composition = state.composition.data;
        this.isLoading = state.composition.status === 'loading';
        this.ready = !this.isLoading && !!state.composition.data;
    }

    static get styles() {
        return css`
            sdb-content-button[light] {
                --text-light: var(--tcg-primary-color-ontertiary, #fff);
            }
        `;
    }

    render() {
        if (!this.ready)
            return nothing;

        return html`
            <sdb-content-button
                label=${this._getCaption()}
                ?disabled=${this.isLoading || this.disabled}
                ?light=${this.light}
                @click=${(e) => { this._executeAction(e); }}>
            </sdb-content-button>
        `;
    }

    firstUpdated() {
        if (this.compositionId) {
            store.dispatch(load({ compositionId: this.compositionId }));
        }
    }

    _getCaption() {
        switch (this.composition.progress) {
            case 'incomplete': return translate('btnIncomplete');
            case 'completed': return translate('btnCompleted');
            default: return translate('btnStart');
        }
    }

    _executeAction(e) {
        if (this.composition.progress === 'started') {
            store.dispatch(start({ compositionId: this.composition.id }));
        }

        if (this._isSingleItem()) {
            store.dispatch(launchElearning({ item: this.composition.items[0] }));
        }

        this.dispatchEvent(
            new CustomEvent('start', {
                bubbles: true,
                composed: true,
                detail: {
                    isSingleItem: this._isSingleItem(),
                },
                target: e.target
            })
        );
    }

    _isSingleItem() {
        return this.composition.compositionType === compositionTypes.COMPOSITIONTYPE_SINGLEITEM;
    }
}
